/**
 * PURPOSE: Estado de los flags del Centro de Programación (FTR-0028) para toda la SPA.
 * RESPONSIBILITIES: Una sola consulta compartida, renovada al minuto, y un hook con
 *   { loading, enabled, publicEnabled, hooksEnabled }. Mientras carga, `enabled` es false: la interfaz
 *   no debe ofrecer el Centro hasta tener una confirmación del backend (fail closed, misma regla que
 *   el servicio). En WG1 nadie lo consume todavía; el botón "Armar Fixture" llega en WG3.
 * COLLABORATORS: services/programmingCenterService.js. Mismo patrón que useUniformOptionsStatus.js.
 * ROUTE: winscore/src/hooks/useProgrammingCenterStatus.js
 */
import { useEffect, useState } from "react";

import {
  PROGRAMMING_CENTER_STATUS_OFF,
  getProgrammingCenterStatus,
} from "../services/programmingCenterService.js";

const TTL_MS = 60 * 1000;
let cache = null;

export const loadProgrammingCenterStatus = () => {
  if (!cache || Date.now() - cache.at > TTL_MS) {
    cache = { at: Date.now(), promise: getProgrammingCenterStatus() };
  }
  return cache.promise;
};

/** Solo para pruebas y para forzar una relectura tras un cambio de sesión. */
export const resetProgrammingCenterStatusCache = () => {
  cache = null;
};

export const useProgrammingCenterStatus = () => {
  const [state, setState] = useState({ loading: true, ...PROGRAMMING_CENTER_STATUS_OFF });
  useEffect(() => {
    let active = true;
    loadProgrammingCenterStatus().then((status) => {
      if (active) setState({ loading: false, ...status });
    });
    return () => {
      active = false;
    };
  }, []);
  return state;
};
